import React, { useEffect, useState } from 'react';
import { Cloud, AlertTriangle, Info, Calendar, Shield, Newspaper } from 'lucide-react';
import TopBar from '../components/common/TopBar';
import BottomNav from '../components/common/BottomNav';
import LoadingSpinner from '../components/common/LoadingSpinner';
import api from '../services/api';

const CATEGORIES = {
  clima: { icon: Cloud, color: 'text-blue-500', label: 'Clima' },
  evento: { icon: Calendar, color: 'text-accent', label: 'Evento' },
  aviso: { icon: AlertTriangle, color: 'text-yellow-600', label: 'Aviso' },
  turismo: { icon: Info, color: 'text-secondary', label: 'Turismo' },
  seguranca: { icon: Shield, color: 'text-destructive', label: 'Segurança' },
};

const BeachInfo = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/news')
      .then((res) => setNews(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background pb-20" data-testid="beach-info-page">
      <TopBar title="Informações da Praia" showBack />

      <div className="max-w-md mx-auto p-4">
        {loading ? (
          <LoadingSpinner />
        ) : news.length === 0 ? (
          <div className="bg-white rounded-xl border border-border p-8 text-center">
            <Newspaper className="w-12 h-12 mx-auto text-muted-foreground mb-2" strokeWidth={1.5} />
            <p className="font-semibold">Sem novidades por enquanto</p>
            <p className="text-xs text-muted-foreground mt-1">Avisos, eventos e clima aparecerão aqui</p>
          </div>
        ) : (
          <div className="space-y-3">
            {news.map((item) => {
              const cat = CATEGORIES[item.category] || CATEGORIES.aviso;
              const Icon = cat.icon;
              return (
                <div
                  key={item.id}
                  data-testid={`news-${item.id}`}
                  className="bg-white rounded-xl border border-border overflow-hidden"
                >
                  {item.image_url && (
                    <img src={item.image_url} alt={item.title} className="w-full h-40 object-cover" />
                  )}
                  <div className="p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <Icon className={`w-4 h-4 ${cat.color}`} />
                      <span className={`text-xs font-semibold uppercase ${cat.color}`}>
                        {cat.label}
                      </span>
                      <span className="text-xs text-muted-foreground ml-auto">
                        {new Date(item.published_at).toLocaleDateString('pt-BR')}
                      </span>
                    </div>
                    <h3 className="font-['Outfit'] font-bold text-foreground">{item.title}</h3>
                    <p className="text-sm text-muted-foreground mt-1 whitespace-pre-line">
                      {item.content}
                    </p>
                    {item.link && (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block mt-2 text-sm font-semibold text-primary hover:underline"
                      >
                        Saiba mais →
                      </a>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
};

export default BeachInfo;
